import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import WithSidebar from 'Layout/WithSidebar';
import Banner from 'components/Banner';
import bannerImage from 'images/detail-of-crop-banner.jpg';
import ProductSidebar from 'components/ProductSidebar';
import PictureComponent from 'components/PictureComponent';
import image from 'images/crop-nutrition-programs-info.jpg';
import BenefitsCards from 'components/BenefitsCards';
import { fetchOneCropNutrition } from 'store/getOneCropNutritionSlice';
import { fetchCropNutrition } from 'store/getCropNutritionSlice';

const DetailedOfCropNutrition = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { title, purposes } = useSelector(state => state?.oneCropNutrition?.data?.data) || {};
    const { crops } = useSelector(state => state?.cropNutrition?.data?.data) || {};
    const otherCrops = crops?.filter(el => el.title !== title);

    useEffect(() => {
        const slug = location.pathname.split('/').pop();
        dispatch(fetchOneCropNutrition({ slug }));
        dispatch(fetchCropNutrition({}));
    }, [dispatch, location.pathname]);

    return (
        <>
            <Banner title={title} image={bannerImage} buttonText="View program" />
            <section className="container">
                <WithSidebar
                    containerType="type-1"
                    mobileReversed
                    Sidebar={<ProductSidebar title="Nutrition program for other crops" data={otherCrops} />}
                >
                    <div className="box">
                        <PictureComponent srcBig={image} className="pb-24" />
                        <h3>Purpose of processing</h3>
                        <BenefitsCards data={purposes} />
                    </div>
                </WithSidebar>
            </section>
        </>
    );
};

export default DetailedOfCropNutrition;
